import { SINE_NORMAL } from 'app/views/home/webgl/particlesOptimised/core/kernels/sine';
import { SineGridPhase } from 'app/views/home/webgl/particlesOptimised/departments/spaces/phases/SineGridPhase';

/**
 * SineWaveGridNormalPhase — FORK of SpacesDepartment._sineWaveGridNormal.
 *
 * VISUAL: the plainest of the three sine grids — a steady travelling wave
 * with uniform crest response (xYIncrease pinned to 1, scale gain 2) and
 * the faster amplitude drift (yChange 0.2).
 */
export class SineWaveGridNormalPhase extends SineGridPhase {
	public readonly name = 'SineWaveGridNormal';

	public start(): void {
		this._state.sineType = SINE_NORMAL;

		this._state.xIncrease = 5;
		this._state.maxSineX = 10;
		this._state.minSineX = -10;
		this._state.sineDirection = 1;
		this._state.sineYChange = 0.2;
		this._state.sinePlaySeed = 2.5;

		this.startSine();
	}
}
